module.exports = __webpack_public_path__ + "static/media/faucet.b38acd5b.svg";